import React from 'react';
// eslint-disable-next-line symbol-description
var EMPTY = Symbol();
export default function createContainer(useHook) {
    var Context = React.createContext(EMPTY);
    function Provider(props) {
        var value = useHook(props.initialState);
        return React.createElement(Context.Provider, { value: value }, props.children);
    }
    function useContainer() {
        var value = React.useContext(Context);
        if (value === EMPTY) {
            throw new Error('Component must be wrapped with <Container.Provider>');
        }
        return value;
    }
    var Consumer = Context.Consumer;
    return { Provider: Provider, useContainer: useContainer, Consumer: Consumer };
}
